.message {
  --Messenger-Bubble-Incoming-Main: var(--message-incoming-bg);
  --Messenger-Bubble-Outgoing-Main: var(--message-outgoing-bg);
  --message-width: 88%;

  border-radius: 14px;
  padding: 10px 12px;
  background: var(--Messenger-Bubble-Incoming-Main);
  width: var(--message-width);

  & .fileItem {
    padding: 0;
  }
}

.outgoing {
  background: var(--Messenger-Bubble-Incoming-Main);
}

.incoming {
  background-color: var(--Messenger-Bubble-Outgoing-Main);
}

.author {
  color: var(--author-color);
}

.outgoing .author {
  color: var(--author-outgoin-color);
}

.content {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 6px;
  width: 100%;
}

.text {
  overflow-wrap: anywhere;
  white-space: break-spaces;
  color: var(--agent-text-color);
}

.outgoing .text {
  color: var(--author-text-color);
}

.textHtml {
  overflow-wrap: anywhere;
  color: var(--agent-text-color);
  font-size: 15px;
}

.outgoing .textHtml {
  color: var(--author-text-color);
}

.messageMeta {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-wrap: nowrap;
}

.sentMessageIcon {
  color: var(--sent-message-icon-color);
}

.notSentMessageIcon {
  color: var(--vkui--color_icon_secondary);
}

.time {
  color: var(--vkui--color_text_secondary);
}

.outgoing .time {
  color: var(--outgoing-time-color);
}

.statusInfo {
  width: var(--message-width);
  padding: 8px 12px 0;
  text-align: right;
}

.error {
  color: var(--vkui--color_text_negative);
}

.files {
  margin-top: 12px;
}
